import { RecipeSearchParam } from "../searchParams/recipeSearchParam.ts";
import GenerateQuery from "./generateQuery.ts";

const GenerateRecipesQuery = (searchParam: RecipeSearchParam) => {
    let query = GenerateQuery(searchParam);
    if (query.length == 0) query = '?';

    if (searchParam.userID != null && searchParam.userID != 0)
        query += `userID=${encodeURIComponent(searchParam.userID!)}&`;
    if (searchParam.duration != null && searchParam.duration != 0)
        query += `duration=${encodeURIComponent(searchParam.duration!)}&`;
    if (searchParam.isPublished != null)
        query += `isPublished=${encodeURIComponent(searchParam.isPublished!)}&`;
    if (searchParam.isPublished != null)
        query += `isValidated=${encodeURIComponent(searchParam.isValidated!)}&`;

    if (query == '?')
        return '';

    return query;
}
export default GenerateRecipesQuery;